let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cBmO4")).then(() => parcelRequire('ab9yn'));